import { z } from 'zod';

// ═══════════════════════════════════════════════════
//  Decorative pillow design vocabulary
// ═══════════════════════════════════════════════════
//
// A separate catalog from upholstery_designs rather than a scope column on it:
// the traits are disjoint. Nothing about a pillow has channels, tufting or
// buttons, and eight cost helpers plus SEEDED_DESIGN_TRAITS already depend on
// that table's four-trait shape.

/**
 * The three designs this feature shipped with. **Not** a validation gate — the
 * `pillow_designs` table is. This list exists for exactly three consumers:
 * PillowDesignsSeedService, SEEDED_PILLOW_TRAITS, and the tests that assert the
 * two agree.
 *
 * Adding a design does NOT mean adding it here. It means inserting a row.
 */
export const SEEDED_PILLOW_DESIGN_KEYS = ['knife_edge', 'welt_edge', 'bolster'] as const;

export type SeededPillowDesignKey = typeof SEEDED_PILLOW_DESIGN_KEYS[number];

/**
 * A pillow design key, validated by *shape* rather than by membership — the
 * same call UpholsteryDesignKeySchema makes, for the same reason.
 *
 * The regex is not decoration. The key is stored verbatim inside
 * line_items.decorative_pillow_config and is a top-level object key in the
 * pl_design_type_overrides JSONB map, so a key with a space, a dot or a comma
 * in it would silently fail to match itself in at least one of those.
 */
export const PillowDesignKeySchema = z
  .string()
  .min(1)
  .max(64)
  .regex(
    /^[a-z][a-z0-9_]*$/,
    'Key must be lowercase letters, digits and underscores, starting with a letter',
  );
